import { render } from "./DocumentActions.vue?vue&type=template&id=6a7da65b"
import script from "./DocumentActions.vue?vue&type=script&lang=js"
export * from "./DocumentActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__